import React,{useState,useEffect,useContext,createContext} from 'react'
import {Navigate,useNavigate} from 'react-router-dom'
import {Form,Button,Container,Card,Alert,Table,Modal,Navbar,NavDropdown,Nav,Row,Col,Accordion} from 'react-bootstrap'
import '../../css/style.css'
import {UserContext} from '../../context/UserContext'
import moment from 'moment'


import Footer from '../Components/Footer'
import axios from 'axios'

export default function Events() {
    const {isAuth,setIsAuth}=useContext(UserContext)
    const {apiToken,setApiToken} = useContext(UserContext)
    const {userID,setUserID }= useContext(UserContext)
    const {usrPhoto,setUsrPhoto}= useContext(UserContext)
    const {firstName,lastName}= useContext(UserContext)
    const [isLoading,setIsLoading]=useState(false)
    const {sportID,langID}= useContext(UserContext)
    const [events,setEvents]=useState([])
    const [attEvents,setAttEvents]=useState([])
    const navigate=useNavigate()

    useEffect(()=>{
        sessionStorage.removeItem("eventTag")

        loadData()
        loadAttEvents()

        window.scrollTo({ top: 0, behavior: 'smooth' })
    },[])


    const loadAttEvents=()=>{
      setIsLoading(true)
      axios.get(process.env.REACT_APP_API_SERVER+'events/attendee/'+userID,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("token")
            }            
        })
      .then(res=>{

        setAttEvents(res.data.results)
        //console.log(res.data.results)
         setIsLoading(false)
      }).catch(err=>{
          setIsLoading(false)
          //console.log(err)
      })          
  }

    const loadData=()=>{
        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'events/'+sportID,{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("token")
              }            
          })
        .then(res=>{

          setEvents(res.data.results)
          //console.log(res.data.results)
           setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)
            //console.log(err)
        })          
    }



    const eventsList=events.map(item=>{

      const borderColor = attEvents.filter(e=>e.EventID===item.id).length>0 ? attEvents.filter(e=>e.EventID===item.id)[0].IsScanned==1 ? 'green' :'orange' : '#5A4E4E'
      const color=item.Disabled ? 'red' : 'white'

      return(

        
        <>

        <div 
          className="settings-item" 
          style={{backgroundColor:'#5A4E4E',borderRadius:'5px',color:'white',padding:'10px',marginBottom:'10px',borderColor,borderWidth:'5px',borderStyle:'solid'}}
          onClick={()=>{
              if (!item.Disabled){
                  navigate('/events/'+item.UUID)
              }
            }}
        >
        <div className="setting-title">
            <div className="setting-icon">
              <i className="bi bi-calendar-fill"></i>
            </div>    
            <div className="setting-text" style={{color}}>{item.Title} </div>    
        </div>
        <div className="setting-value" style={{color}}>{moment(item.DateFrom).format('DD/MM/YYYY')} <br/>{item.Location}</div>      
        </div>

        {/* <div className="settings-item">
          {item.Disabled &&
            <Alert variant="danger">Event is closed</Alert>
          
          }
          {!item.Disabled &&
          <>Click on a category below to join the event</>
          }
          
        </div>

        <div className="settings-item" style={{alignContent:'center',justifyContent:'center',display:'flex',alignItems:'center'}}>
          
        <Row>
          {item.Tags.split(',').map(tag=>{
            return(
              
              <Col md={12}><Button disabled={item.Disabled} variant="dark" style={{width:'100%',marginBottom:'10px'}} onClick={()=>joinEvent(tag,item.UUID)}>{tag}</Button></Col>
              
            )
          })}
          </Row>
        </div>
        <hr/> */}

        </>
      )
    })




  return (
    <>
      <header>
          <div className="upper-section upper-dark">
            <div className="d-flex align-items-center">
                {/* <div className="upper-arrow">
                    <button><img src="images/left-arrow.png"/></button>
                  </div> */}
              <div className="upper-texts">
                <div className="text1-w">events</div>
                <div className="text2-g2">{firstName} {lastName}</div>
              </div>
            </div>
            <div onClick={()=>navigate('/profile/'+userID)}  className="upper-photo" style={{backgroundImage:'url('+usrPhoto+')'}}></div>
          </div>    
      </header>

         <section className="pb-4 section-margin">       
        
        {isLoading &&
          <div className="alert alert-warning" role="alert">
          Loading, please wait...
          </div>          
        }
        
        {!isLoading &&
            

          <>{eventsList}</>

            
        }
        </section>
  </>
  )
}
